import type { BusinessClientRepository } from "../../../domain/repositories/company/business-client-repository";
import { businessClientApiService } from "../../api/company/business-client-api-service";
import type {
  BusinessClient,
  BusinessClientDetail,
  OrderFile,
} from "../../../domain/types/business-client";
import type { PageResponse } from "../../../shared/types/api";

export class BusinessClientRepositoryImpl implements BusinessClientRepository {
  async getBusinessClients(
    companyId: number,
    keyword?: string,
    page?: number,
    size?: number,
  ): Promise<PageResponse<BusinessClient>> {
    const response = await businessClientApiService.getBusinessClients(companyId, keyword, page, size);
    if (!response.data) {
      throw new Error(response.errorMsg || "기업고객 목록을 불러오지 못했습니다.");
    }
    return response.data;
  }

  async getBusinessClientDetail(
    companyId: number,
    userId: number,
  ): Promise<BusinessClientDetail> {
    const response = await businessClientApiService.getBusinessClientDetail(companyId, userId);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "기업고객 상세 정보를 불러오지 못했습니다.");
  }

  async getBusinessClientOrders(
    companyId: number,
    userId: number,
    params?: { status?: string; dateFrom?: string; dateTo?: string; page?: number; size?: number },
  ): Promise<PageResponse<any>> {
    const response = await businessClientApiService.getBusinessClientOrders(companyId, userId, params);
    if (!response.data) {
      throw new Error(response.errorMsg || "기업고객 주문내역을 불러오지 못했습니다.");
    }
    return response.data;
  }

  async getBusinessClientOrderFiles(
    companyId: number,
    userId: number,
    page?: number,
    size?: number,
  ): Promise<PageResponse<OrderFile>> {
    const response = await businessClientApiService.getBusinessClientOrderFiles(companyId, userId, page, size);
    if (!response.data) {
      throw new Error(response.errorMsg || "기업고객 주문 파일 목록을 불러오지 못했습니다.");
    }
    return response.data;
  }
}